namespace TabAurous.HR {
    export namespace IncomeTaxSlabsService {
        export const baseUrl = 'HR/IncomeTaxSlabs';

        export declare function Create(request: Serenity.SaveRequest<IncomeTaxSlabsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IncomeTaxSlabsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IncomeTaxSlabsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IncomeTaxSlabsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "HR/IncomeTaxSlabs/Create",
            Update = "HR/IncomeTaxSlabs/Update",
            Delete = "HR/IncomeTaxSlabs/Delete",
            Retrieve = "HR/IncomeTaxSlabs/Retrieve",
            List = "HR/IncomeTaxSlabs/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IncomeTaxSlabsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
